// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".navbar[data-v-26df50c0]{padding:0;min-height:50px;background-color:#fff}.navbar img.brand-logo[data-v-26df50c0]{max-height:50px}", ""]);
// Exports
module.exports = exports;
